import axios from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import queryKeys from './queryKeys'
import { SESSIONS_ME_API } from './constants'

export const useGetSessionUser = (enabled: boolean) => {
  const getSessionUserApi = `${getAppConfigSetting('oktaUrl')}${SESSIONS_ME_API}`

  const getSessionUser = async () => {
    const { data } = await axios.get(getSessionUserApi, {
      withCredentials: true
    })

    return data
  }

  return useQuery([queryKeys.sessionUser], getSessionUser, {
    enabled,
    retry: false,
    staleTime: Infinity
  })
}
